var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 236.695,
    height: 24.311,
    viewBox: "0 0 236.695 24.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{stroke:rgba(0,0,0,0);}.a,.b{fill:url(#a);}.c{fill:#3f3e3e;}.d{fill:url(#e);}.e{clip-path:url(#f);}.f{clip-path:url(#i);}.g{clip-path:url(#l);}.h{clip-path:url(#o);}.brokers{fill:#3f3e3e;stroke:#3f3e3e;stroke-width:1;stroke-linecap:round;stroke-linejoin:round;clip-path:url(#brokers-bounds);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db0617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#a50011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a50011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db0617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963,
    stopColor: "#a50011"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.152,12.352l-.868.876L1.319,15.214l-.869.877A1.552,1.552,0,0,0,.46,18.286l.876.87,1.985,1.961.876.869a1.553,1.553,0,0,0,2.2-.012l3.7-3.735a1.553,1.553,0,0,0-.01-2.195l-3.735-3.7a1.552,1.552,0,0,0-2.2.011",
    transform: "translate(0 -11.892)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.043,24l-3.7,3.735a1.554,1.554,0,0,0,.011,2.2l.878.87,1.98,1.965.877.869a1.553,1.553,0,0,0,2.2-.01l.868-.877,1.965-1.984.868-.879a1.55,1.55,0,0,0-.011-2.195l-3.737-3.7a1.554,1.554,0,0,0-2.2.012",
    transform: "translate(-11.896 -23.535)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.682,12.1l-3.7,3.739a1.552,1.552,0,0,0,.011,2.2l3.738,3.7a1.552,1.552,0,0,0,2.195-.011l.869-.877,1.961-1.981.869-.879a1.552,1.552,0,0,0-.011-2.195l-.877-.869-1.981-1.966-.877-.869a1.552,1.552,0,0,0-2.2.011",
    transform: "translate(-23.531 -11.636)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.789.46l-.869.877L12.96,3.317l-.87.879A1.552,1.552,0,0,0,12.1,6.389l3.734,3.7a1.551,1.551,0,0,0,2.2-.01l3.7-3.739a1.555,1.555,0,0,0-.011-2.2l-.877-.869L18.862,1.318,17.985.449a1.552,1.552,0,0,0-2.2.011",
    transform: "translate(-11.642)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brokers-bounds",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.285,
    y: 0,
    width: 97.41,
    height: 24.311
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M54.316,23.51A11.556,11.556,0,0,1,50.9,21.758a8.022,8.022,0,0,1-2.515-3.249,11.586,11.586,0,0,1-.933-4.79,11.584,11.584,0,0,1,.933-4.789A8.026,8.026,0,0,1,50.9,5.68a11.569,11.569,0,0,1,3.418-1.752,12.7,12.7,0,0,1,3.843-.579,11.637,11.637,0,0,1,7.318,2.373.806.806,0,0,1,.2,1.158L64.459,9.029q-.452.791-1.186.2a8.208,8.208,0,0,0-5.114-1.808,5.938,5.938,0,0,0-4.351,1.638,6.24,6.24,0,0,0-1.668,4.662,6.245,6.245,0,0,0,1.668,4.663,5.94,5.94,0,0,0,4.351,1.638,8.5,8.5,0,0,0,5.17-1.638q.736-.538,1.158.225l1.244,2.233q.367.705-.057,1.017a12.457,12.457,0,0,1-7.516,2.232,12.7,12.7,0,0,1-3.843-.579",
    transform: "translate(-19.693 -1.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M94.3,19.88a.748.748,0,0,1,.847.847V23.1a.748.748,0,0,1-.847.848h-11.9a.749.749,0,0,1-.848-.848V5.018a.749.749,0,0,1,.848-.847h2.769a.748.748,0,0,1,.847.847V19.88Z",
    transform: "translate(-33.851 -1.731)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M112.587,23.72a11.064,11.064,0,0,1-2.882-1.172,9.808,9.808,0,0,1-2.443-1.978,8.879,8.879,0,0,1-1.682-2.938,11.486,11.486,0,0,1-.635-3.914,11.474,11.474,0,0,1,.635-3.913,8.873,8.873,0,0,1,1.682-2.939A9.81,9.81,0,0,1,109.7,4.889a11.1,11.1,0,0,1,2.882-1.172,12.721,12.721,0,0,1,6.075,0,11.091,11.091,0,0,1,2.882,1.172,9.792,9.792,0,0,1,2.444,1.978,8.852,8.852,0,0,1,1.681,2.939,11.46,11.46,0,0,1,.636,3.913,11.471,11.471,0,0,1-.636,3.914,8.857,8.857,0,0,1-1.681,2.938,9.79,9.79,0,0,1-2.444,1.978,11.052,11.052,0,0,1-2.882,1.172,12.721,12.721,0,0,1-6.075,0m7.36-5.34a6.242,6.242,0,0,0,1.667-4.662,6.242,6.242,0,0,0-1.667-4.662,6.524,6.524,0,0,0-8.646,0,6.244,6.244,0,0,0-1.666,4.662,6.244,6.244,0,0,0,1.666,4.662,6.522,6.522,0,0,0,8.646,0",
    transform: "translate(-43.556 -1.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M156.476,4.171h3a.746.746,0,0,1,.663.268.761.761,0,0,1,.014.721L153.14,23.271a.919.919,0,0,1-.959.678h-3.5a.922.922,0,0,1-.961-.678L140.71,5.16a.763.763,0,0,1,.013-.721.75.75,0,0,1,.665-.268h3.024a.941.941,0,0,1,.989.678l5.058,13.929,5.03-13.929a.94.94,0,0,1,.989-.678",
    transform: "translate(-58.366 -1.731)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M190.209,8.24h-9.8v3.673h8.306a.749.749,0,0,1,.848.847v2.119a.75.75,0,0,1-.848.849h-8.306v4.153h9.747a.749.749,0,0,1,.848.847V23.1a.75.75,0,0,1-.848.848H176.788a.749.749,0,0,1-.847-.848V5.019a.748.748,0,0,1,.847-.847h13.421a.748.748,0,0,1,.847.847V7.392a.749.749,0,0,1-.847.848",
    transform: "translate(-73.022 -1.732)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M221.359,23.666a.725.725,0,0,1-.677.283h-3.419a1.165,1.165,0,0,1-1.017-.538l-4.351-6.639h-3.052V23.1a.75.75,0,0,1-.847.849h-2.77a.75.75,0,0,1-.848-.849V5.019a.749.749,0,0,1,.848-.848h6.357q9.24,0,9.239,5.99a5.746,5.746,0,0,1-4.238,5.848l4.662,6.923q.283.452.112.734M208.842,12.929h2.487q4.8,0,4.8-2.486,0-2.2-4.8-2.2h-2.487Z",
    transform: "translate(-84.824 -1.731)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "brokers"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M238.205,3.794a.323.323,0,0,1,.266-.107h.012q.329,0,.329.4v8.772a8,8,0,0,1,1.766-2.511,8.315,8.315,0,0,1,2.607-1.71,7.882,7.882,0,0,1,3.061-.612,7.446,7.446,0,0,1,3.9,1.085,8.146,8.146,0,0,1,2.878,2.936,7.832,7.832,0,0,1,1.073,3.994A7.594,7.594,0,0,1,253,20.005a8.241,8.241,0,0,1-2.909,2.91,7.42,7.42,0,0,1-3.85,1.079,7.941,7.941,0,0,1-3.068-.606,8.387,8.387,0,0,1-2.6-1.691,7.932,7.932,0,0,1-1.766-2.474v4.026q0,.4-.329.4h-.012a.323.323,0,0,1-.266-.107.456.456,0,0,1-.088-.3V4.09a.454.454,0,0,1,.088-.3m1.629,15.865a7.577,7.577,0,0,0,2.739,2.656,7.286,7.286,0,0,0,3.686.984,6.714,6.714,0,0,0,3.5-.984,7.5,7.5,0,0,0,2.638-2.656,6.977,6.977,0,0,0,.99-3.617,7.222,7.222,0,0,0-.972-3.666,7.337,7.337,0,0,0-2.613-2.67,6.767,6.767,0,0,0-3.545-.984,7.292,7.292,0,0,0-3.7.984,7.51,7.51,0,0,0-2.727,2.67,6.982,6.982,0,0,0-1.015,3.666,6.814,6.814,0,0,0,1.022,3.617",
    transform: "translate(-98.827 -1.53)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M268.182,11.367h.013q.327,0,.328.391v3.219a4.7,4.7,0,0,1,1.389-1.894,6.368,6.368,0,0,1,2.045-1.143,6.751,6.751,0,0,1,2.144-.372,5.489,5.489,0,0,1,1.843.347,7.076,7.076,0,0,1,1.647.813c.45.311.676.569.676.771a.2.2,0,0,1-.051.15l-.012.013a.348.348,0,0,1-.277.139.391.391,0,0,1-.265-.115,5.482,5.482,0,0,0-3.522-1.426,5.973,5.973,0,0,0-2.587.612,5.182,5.182,0,0,0-2.152,1.969,6.284,6.284,0,0,0-.864,3.438v8.154q0,.4-.341.4h-.013q-.34,0-.34-.4V11.758q0-.391.34-.391",
    transform: "translate(-111.164 -4.718)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M288.423,15.049a7.86,7.86,0,0,1,2.859-2.9,7.631,7.631,0,0,1,3.95-1.067,7.949,7.949,0,0,1,4.033,1.074,8.14,8.14,0,0,1,2.959,2.9,7.578,7.578,0,0,1,1.1,3.982,7.684,7.684,0,0,1-1.1,3.994,8.236,8.236,0,0,1-2.953,2.941,7.771,7.771,0,0,1-4.013,1.092,7.529,7.529,0,0,1-3.95-1.092,8.04,8.04,0,0,1-2.878-2.941,8.063,8.063,0,0,1-.006-7.982m.606,7.636a7.329,7.329,0,0,0,2.619,2.688,6.854,6.854,0,0,0,3.609,1,7.224,7.224,0,0,0,3.737-1,7.3,7.3,0,0,0,2.662-2.681,7.187,7.187,0,0,0,.972-3.654,6.923,6.923,0,0,0-1-3.634,7.44,7.44,0,0,0-2.7-2.645,7.272,7.272,0,0,0-3.692-.978,6.957,6.957,0,0,0-3.6.972,7.245,7.245,0,0,0-3.565,6.285,7.24,7.24,0,0,0,.966,3.648",
    transform: "translate(-119.269 -4.601)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M330.2,23.063a.393.393,0,0,1,.1.24.308.308,0,0,1-.1.233.386.386,0,0,1-.226.107.569.569,0,0,1-.2-.031.623.623,0,0,1-.208-.184l-7.142-9.313-3.458,3.155v5.944c0,.287-.109.429-.329.429h-.013a.291.291,0,0,1-.259-.119.537.537,0,0,1-.081-.309V4.056c0-.26.113-.391.34-.391h.013c.219,0,.329.131.329.391V16.336L327.7,8.348a.69.69,0,0,1,.2-.139.47.47,0,0,1,.158-.026.358.358,0,0,1,.24.1.341.341,0,0,1,.113.266.337.337,0,0,1-.113.239l-5.364,4.859Z",
    transform: "translate(-132.1 -1.521)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M340.331,19.135a7.037,7.037,0,0,0,.978,3.616,7.411,7.411,0,0,0,2.644,2.663,6.969,6.969,0,0,0,3.623.99,7.349,7.349,0,0,0,2.12-.278,6.5,6.5,0,0,0,1.533-.656,14.3,14.3,0,0,0,1.332-.947.474.474,0,0,1,.3-.113.256.256,0,0,1,.19.076l.025.025a.254.254,0,0,1,.076.19.42.42,0,0,1-.152.315,9.2,9.2,0,0,1-2.441,1.5A8.052,8.052,0,0,1,343.606,26a8.023,8.023,0,0,1-2.895-2.9,7.689,7.689,0,0,1-1.074-3.969,7.827,7.827,0,0,1,1.074-4A8.132,8.132,0,0,1,343.6,12.2a7.53,7.53,0,0,1,3.949-1.092,7.608,7.608,0,0,1,4.052,1.13,8.539,8.539,0,0,1,2.9,2.884,6.752,6.752,0,0,1,1.061,3.52v.051a.308.308,0,0,1-.354.341h-14.88Zm3.837-6.449a7.483,7.483,0,0,0-2.588,2.384,7.267,7.267,0,0,0-1.211,3.282h14.5a6.422,6.422,0,0,0-1.073-3.016,7.942,7.942,0,0,0-2.613-2.53,7,7,0,0,0-7.016-.12",
    transform: "translate(-140.962 -4.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M369.1,11.367h.012c.219,0,.328.13.328.391v3.219a4.713,4.713,0,0,1,1.389-1.894,6.38,6.38,0,0,1,2.045-1.143,6.755,6.755,0,0,1,2.145-.372,5.5,5.5,0,0,1,1.843.347,7.1,7.1,0,0,1,1.647.813c.45.311.675.569.675.771a.2.2,0,0,1-.05.15l-.013.013a.348.348,0,0,1-.277.139.392.392,0,0,1-.265-.115,5.481,5.481,0,0,0-3.522-1.426,5.975,5.975,0,0,0-2.587.612,5.188,5.188,0,0,0-2.151,1.969,6.279,6.279,0,0,0-.865,3.438v8.154q0,.4-.341.4H369.1q-.34,0-.341-.4V11.758q0-.391.341-.391",
    transform: "translate(-153.047 -4.718)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M389.678,26.521a4.243,4.243,0,0,1-1.717-1.508,3.474,3.474,0,0,1-.568-1.849c0-.2.068-.328.2-.378l.038-.012a.427.427,0,0,1,.126-.026.305.305,0,0,1,.253.139.631.631,0,0,1,.112.341,2.974,2.974,0,0,0,.644,1.71,3.627,3.627,0,0,0,1.54,1.1,5.838,5.838,0,0,0,2.159.379,6.271,6.271,0,0,0,1.956-.323A3.73,3.73,0,0,0,396.1,25a3.022,3.022,0,0,0,.689-2.07,2.916,2.916,0,0,0-1.18-2.505,9.032,9.032,0,0,0-3.175-1.358,12.8,12.8,0,0,1-2.442-.807,4.14,4.14,0,0,1-1.6-1.256,3.212,3.212,0,0,1-.594-1.988,3.8,3.8,0,0,1,.525-1.957,3.724,3.724,0,0,1,1.564-1.433,5.385,5.385,0,0,1,2.492-.536A5.082,5.082,0,0,1,396.335,13a3.6,3.6,0,0,1,.776,1.868v.1c0,.168-.042.27-.126.3a.288.288,0,0,1-.153.038.4.4,0,0,1-.233-.076.331.331,0,0,1-.133-.226,3.2,3.2,0,0,0-.72-1.654A4.152,4.152,0,0,0,394.24,12.2a4.4,4.4,0,0,0-1.861-.416,4.723,4.723,0,0,0-2.006.41,3.325,3.325,0,0,0-1.383,1.142,2.919,2.919,0,0,0-.5,1.679,2.492,2.492,0,0,0,1.18,2.253,8.4,8.4,0,0,0,2.82,1.092q4.986,1.1,4.986,4.569a3.652,3.652,0,0,1-.77,2.391,4.441,4.441,0,0,1-1.918,1.369,6.577,6.577,0,0,1-2.322.43,6.019,6.019,0,0,1-2.79-.594",
    transform: "translate(-160.782 -4.601)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.956)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M4.152,12.352l-.868.876L1.319,15.214l-.869.877A1.552,1.552,0,0,0,.46,18.286l.876.87,1.985,1.961.876.869a1.553,1.553,0,0,0,2.2-.012l3.7-3.735a1.553,1.553,0,0,0-.01-2.195l-3.735-3.7a1.552,1.552,0,0,0-2.2.011",
    transform: "translate(0 -11.892)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 10.849,
    height: 10.696,
    transform: "translate(-0.154 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.959 13.767)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.043,24l-3.7,3.735a1.554,1.554,0,0,0,.011,2.2l.878.87,1.98,1.965.877.869a1.553,1.553,0,0,0,2.2-.01l.868-.877,1.965-1.984.868-.879a1.55,1.55,0,0,0-.011-2.195l-3.737-3.7a1.554,1.554,0,0,0-2.2.012",
    transform: "translate(-11.896 -23.535)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 10.848,
    height: 10.698,
    transform: "translate(-0.154 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.765 6.807)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M27.682,12.1l-3.7,3.739a1.552,1.552,0,0,0,.011,2.2l3.738,3.7a1.552,1.552,0,0,0,2.195-.011l.869-.877,1.961-1.981.869-.879a1.552,1.552,0,0,0-.011-2.195l-.877-.869-1.981-1.966-.877-.869a1.552,1.552,0,0,0-2.2.011",
    transform: "translate(-23.531 -11.636)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 10.85,
    height: 10.699,
    transform: "translate(-0.154 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.81)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M15.789.46l-.869.877L12.96,3.317l-.87.879A1.552,1.552,0,0,0,12.1,6.389l3.734,3.7a1.551,1.551,0,0,0,2.2-.01l3.7-3.739a1.555,1.555,0,0,0-.011-2.2l-.877-.869L18.862,1.318,17.985.449a1.552,1.552,0,0,0-2.2.011",
    transform: "translate(-11.642)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 10.848,
    height: 10.696,
    transform: "translate(-0.154)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/main-logo.e0faccddfdce6b5810eb36e104f31c52.svg";
export { ForwardRef as ReactComponent };